import type { NestMonsterType } from '@/types/monster'
import type { WildUserDataType } from '@/types/wild'
import { socketEmitAsync } from '@/utils/web-socket'
import { defineStore } from 'pinia'

export const useWildStore = defineStore('wild', {
  state: () => {
    return {
      info: {
        times: 0,
        refreshTime: '',
        buyIncense: false,
        map: [],
      } as WildUserDataType,
      canGoMapItemList: [] as number[],
      monsterList: [] as NestMonsterType[],
    }
  },
  actions: {
    async getWildInfo() {
      const res = await socketEmitAsync<WildUserDataType>({ type: 'getWildInfo', limit: false })
      this.info = res
      this.canGoMapItemList = []
      this.info.map.forEach((item) => {
        this.canGoMapItemList.push(item)
        this.canGoMapItemList.push(item + 7, item - 7)
        const isLeft = item % 7 === 0
        if (!isLeft) this.canGoMapItemList.push(item - 1)
        const isRight = (item + 1) % 7 === 0
        if (!isRight) this.canGoMapItemList.push(item + 1)
      })
      this.canGoMapItemList = [...new Set([...this.canGoMapItemList])].filter(
        (item) => item <= 48 && item >= 0 && item !== 24 && !this.info.map.includes(item),
      )
      const monsterRes = await socketEmitAsync<NestMonsterType[]>({
        type: 'getWildMonster',
        data: { indexList: this.canGoMapItemList },
        limit: false,
      })
      this.monsterList = monsterRes
    },
  },
})
